export const englishLocation = [
  { id: 0, title: "Al-Hasakeh" },
  { id: 1, title: "Aleppo" },
  { id: 2, title: "Ar-Raqqa" },
  { id: 3, title: "As-Sweida" },
  { id: 4, title: "Damascus" },
  { id: 5, title: "Dar'a" },
  { id: 6, title: "Deir-ez-Zor" },
  { id: 7, title: "Hama" },
  { id: 8, title: "Homs" },
  { id: 9, title: "Idlib" },
  { id: 10, title: "Lattakia" },
  { id: 11, title: "Quneitra" },
  { id: 12, title: "Rural Damascus" },
  { id: 13, title: "Tartous" },
];

export const typeOfMunition = [
  { id: 0, title: "Barrel bomb" },
  { id: 1, title: "Bunker-buster bomb" },
  { id: 2, title: "Car bomb" },
  { id: 3, title: "Chemical weapons" },
  { id: 4, title: "Cluster munition" },
  { id: 5, title: "Incendiary weapons" },
  { id: 6, title: "Placed explosive" },
  { id: 7, title: "Thermobaric weapon" },
  { id: 8, title: "Car bomb" },
];
export const allegedPerpetrator = [
  { id: 0, title: "Coalition Forces" },
  { id: 1, title: "The YPG/ PYD -SDF" },
  { id: 2, title: "Opposition groups" },
  { id: 3, title: "Perpetrator Contested" },
  { id: 4, title: "Perpetrator Unknown" },
  { id: 5, title: "Pro-Government Militias" },
  { id: 6, title: "Russian Forces" },
  { id: 7, title: "Syrian Armed Forces" },
  { id: 8, title: "Turkish Forces" },
  { id: 9, title: "ISIS" },
  { id: 10, title: "Combined Syrian and Russian Forces" },
  { id: 11, title: "Unaffiliated" },
  { id: 12, title: "Syrian or Russian Forces" },
];
export const areaOfControl = [
  { id: 0, title: "ISIS-controlled area" },
  { id: 1, title: "Opposition-controlled area" },
  { id: 2, title: "SDF/PYD/YPG-controlled area" },
  { id: 3, title: "Syrian government-controlled area" },
  { id: 4, title: "Unknown" },
];
export const isDirectHit = [
  { id: 0, title: "True" },
  { id: 1, title: "False" },
  { id: 2, title: "Unknown" },
];
export const hasCasualties = [
  { id: 0, title: "True" },
  { id: 1, title: "False" },
  { id: 2, title: "Unknown" },
];

export const deliveryMethod = [
  { id: 0, title: "Air strike" },
  { id: 1, title: "Ground attack" },
  { id: 2, title: "Ground-to-ground" },
];

export const allLocations = [];
